/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfDeviceDto } from '../../models/platform-api-result-of-device-dto';

export interface GetDevicesId$Params {
  Id: string;
}

export function getDevicesId(http: HttpClient, rootUrl: string, params: GetDevicesId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfDeviceDto>> {
  const rb = new RequestBuilder(rootUrl, getDevicesId.PATH, 'get');
  if (params) {
    rb.path('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfDeviceDto>;
    })
  );
}

getDevicesId.PATH = '/api/devices/{id}';
